import React from 'react';
import PropTypes from 'prop-types';
import s from './CricketStats.scss';
import Link from '../../../../../components/Link/Link';
import Image from '../../../../../components/Image';
import { statsTableHeaderMap } from './CricketStatsUtils';
import { TOI_IMAGE_DOMAIN, TOI_LIVE_DOMAIN } from '../../../../../constants';
import { getPlayerKey, getPlayerLink } from '../CricketTeamList/utils';

const CricketIPLCapsStats = props => {
  const {
    tableData = {},
    tournamentName,
    topLeaderData,
    activeTab,
    thumbslist,
    defaultThumb,
    capTitle,
  } =
    props || {};

  // const tableDataStats =
  //   cricketCapsStats && activeTab ? cricketCapsStats[activeTab] : [];
  // const tableData =
  //   tableDataStats && Array.isArray(tableDataStats) && tableDataStats.length > 0
  //     ? tableDataStats[0]
  //     : '';
  const tableHeader = statsTableHeaderMap[tableData?.stat_id];
  const tableHeaderMapHead = tableHeader;
  const tablevalueMap = tableHeader && Object.keys(tableHeader);
  const isIpl =
    tableData?.series_name &&
    typeof tableData?.series_name === 'string' &&
    tableData?.series_name.toLowerCase().includes('indian premier league');
  // const topLeaderData =
  //   tableData &&
  //   tableData.leaderboard &&
  //   Array.isArray(tableData.leaderboard) &&
  //   tableData.leaderboard.length > 0
  //     ? tableData.leaderboard[0]
  //     : '';
  let topPlayerkey = topLeaderData && topLeaderData.player_name;
  topPlayerkey = getPlayerKey(topPlayerkey);

  const date = new Date();
  const year = date.getFullYear();

  const numOfSlice = tableData.series_name.includes(year) ? 20 : 10;

  return (
    <>
      <div className={`${s.stats_page_cont} ${s.stats_page_wrapper}`}>
        {tableData && (
          <div
            className={`${s.stats_table} cap_ui ${
              tournamentName === 'ipl' || tournamentName === 'wpl'
                ? 'pointsTableLeague'
                : ''
            }`}
          >
            {topLeaderData && (
              <div
                className={`${s.team_page} ${
                  activeTab && activeTab === 'Purple' ? 'purple_ui' : ''
                }`}
              >
                <div className={s.team_players}>
                  <div className={s.team_details_block}>
                    <div className={`${s.number_count} ${s.only_web}`}>1</div>
                    <div className={s.player_bg} />
                    <div className={s.players_details}>
                      <div className={s.heading}>{capTitle}</div>
                      <div className={s.name_image}>
                        <div className={`${s.number_count} ${s.only_wap}`}>
                          1
                        </div>
                        <span className={s.player_image}>
                          <Link
                            to={getPlayerLink(
                              isIpl,
                              topPlayerkey,
                              topLeaderData?.player_id || topLeaderData?.id,
                              tournamentName,
                            )}
                          >
                            {thumbslist &&
                            thumbslist[topPlayerkey] &&
                            thumbslist[topPlayerkey].strimg ? (
                              <Image
                                key={thumbslist[topPlayerkey].playernameseo}
                                src={thumbslist[topPlayerkey].strimg}
                                placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/42706777.gif`}
                                alt={thumbslist[topPlayerkey].playernameseo}
                                lazyload
                                offsetVertical={200}
                              />
                            ) : (
                              <Image
                                key="default_1"
                                src={defaultThumb}
                                placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/42706777.gif`}
                                alt="default"
                                lazyload
                                offsetVertical={200}
                              />
                            )}
                          </Link>
                        </span>
                        <div className={s.player_name_team}>
                          <div className={s.player_name}>
                            <Link
                              to={getPlayerLink(
                                isIpl,
                                topLeaderData?.player_name,
                                topLeaderData?.player_id || topLeaderData?.id,
                                tournamentName,
                              )}
                            >
                              {topLeaderData?.player_name}
                            </Link>
                          </div>
                          <div className={s.team_name}>
                            {topLeaderData?.team_name}
                          </div>
                        </div>
                      </div>
                    </div>
                    {activeTab &&
                      activeTab === 'Orange' && (
                        <div className={s.cap_wrapper}>
                          <div className={s.cap_info}>
                            <div className={s.run_cap}>
                              <div className={s.run}>
                                {topLeaderData?.runs_scored} <span>runs</span>
                              </div>
                              <div className={`${s.cap_image}`} />
                            </div>
                            <div className={s.match_info}>
                              <div className={s.text_wrap}>
                                <div>Matches:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.matches_played}
                                </div>
                              </div>
                              <div className={s.text_wrap}>
                                <div>Innings:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.innings_played}
                                </div>
                              </div>
                              <div className={s.text_wrap}>
                                <div>SR:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.batting_strike_rate}
                                </div>
                              </div>
                              <div className={s.text_wrap}>
                                <div>Avg:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.average}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {activeTab &&
                      activeTab === 'Purple' && (
                        <div className={s.cap_wrapper}>
                          <div className={s.cap_info}>
                            <div className={s.run_cap}>
                              <div className={s.run}>
                                {topLeaderData?.wickets} <span>wickets</span>
                              </div>
                              <div
                                className={`${s.cap_image} ${s.purplecap}`}
                              />
                            </div>
                            <div className={s.match_info}>
                              <div className={s.text_wrap}>
                                <div>Matches:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.matches_played}
                                </div>
                              </div>
                              <div className={s.text_wrap}>
                                <div>Overs:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.overs}
                                </div>
                              </div>
                              <div className={s.text_wrap}>
                                <div>ER:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.economy}
                                </div>
                              </div>
                              <div className={s.text_wrap}>
                                <div>Avg:</div>
                                <div className={s.numbers}>
                                  {topLeaderData?.best_bowling_average}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            )}
            {tableData.leaderboard &&
              Array.isArray(tableData.leaderboard) &&
              tableData.leaderboard.length > 0 && (
                <ul className={`${s.list} ${s.listActive}`}>
                  <li className={s.head}>
                    <span className={s.rank}>Rank</span>
                    {Object.entries(tableHeaderMapHead).map(
                      ([key, header], index) => (
                        <>
                          {header &&
                            index !== 1 && (
                              <span className={`${s[key]}`}>{header}</span>
                            )}
                          {header &&
                            index === 1 && (
                              <span className={`${s.span_fix} ${s[key]}`}>
                                {header}
                              </span>
                            )}
                          {!header &&
                            index === 0 && (
                              <span className={`${s.player_image} ${s[key]}`}>
                                {header}
                              </span>
                            )}
                        </>
                      ),
                    )}
                  </li>
                  {tableData.leaderboard
                    .slice(1, numOfSlice)
                    .map((item, index) => (
                      <li className={s.selected} key={index}>
                        <span className={s.rank}>
                          <span>{index + 2}</span>
                        </span>
                        {tablevalueMap.map(header => {
                          let playerkey = item && item.player_name;
                          playerkey = getPlayerKey(playerkey);
                          return (
                            <>
                              {header === 'player_pic' && (
                                <span className={s.player_image}>
                                  <Link
                                    to={getPlayerLink(
                                      isIpl,
                                      playerkey,
                                      item?.player_id || item?.id,
                                      tournamentName,
                                    )}
                                  >
                                    {thumbslist &&
                                    thumbslist[playerkey] &&
                                    thumbslist[playerkey].strimg ? (
                                      <Image
                                        key={
                                          thumbslist[playerkey].playernameseo
                                        }
                                        src={thumbslist[playerkey].strimg}
                                        placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/42706777.gif`}
                                        alt={
                                          thumbslist[playerkey].playernameseo
                                        }
                                        lazyload
                                        offsetVertical={200}
                                      />
                                    ) : (
                                      <Image
                                        key="default_1"
                                        src={defaultThumb}
                                        placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/42706777.gif`}
                                        alt="default"
                                        lazyload
                                        offsetVertical={200}
                                      />
                                    )}
                                  </Link>
                                </span>
                              )}
                              {(header === 'player_name' ||
                                header === 'team_short_name') && (
                                <>
                                  {header === 'player_name' && (
                                    <span
                                      className={`${s.name_country} ${
                                        s.span_fix
                                      } ${s[header]}`}
                                    >
                                      <Link
                                        to={getPlayerLink(
                                          isIpl,
                                          playerkey,
                                          item?.player_id || item?.id,
                                          tournamentName,
                                        )}
                                      >
                                        {item[header]}
                                      </Link>
                                      {item.team_short_name && (
                                        <span
                                          className={`${s.countryname} ${
                                            s[header]
                                          }`}
                                        >
                                          <span
                                            className={`${s.teamFlag} ${
                                              s[item.team_short_name]
                                            }`}
                                          />{' '}
                                          {item.team_short_name}
                                        </span>
                                      )}
                                    </span>
                                  )}
                                </>
                              )}
                              {header !== 'team_short_name' &&
                                header !== 'player_name' &&
                                header !== 'player_pic' && (
                                  <span className={`${s[header]}`}>
                                    {header !== 'batting_strike_rate' &&
                                      header !== 'economy' &&
                                      header !== 'average' &&
                                      header !== 'best_bowling_average' &&
                                      item[header]}
                                    {(header === 'batting_strike_rate' ||
                                      header === 'economy' ||
                                      header === 'best_bowling_average') &&
                                      Math.round(item[header])}
                                    {header === 'average' && item[header]}
                                  </span>
                                )}
                            </>
                          );
                        })}
                      </li>
                    ))}
                </ul>
              )}
          </div>
        )}
      </div>
    </>
  );
};

CricketIPLCapsStats.propTypes = {
  sectionItem: PropTypes.shape({
    cricketCapsStats: PropTypes.array,
    tournamentName: PropTypes.string,
  }),
};

CricketIPLCapsStats.defaultProps = {
  sectionItem: {
    cricketCapsStats: [],
    tableData: {},
    topLeaderData: {},
    activeTab: '',
    thumbslist: {},
    defaultThumb: '',
    tournamentName: '',
  },
};

export default CricketIPLCapsStats;
